/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { ChangeDetectorRef, Directive, inject, Input } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';

@Directive()
export abstract class BaseControlValueAccessor<T> implements ControlValueAccessor {
  @Input()
  public value: T | null;

  protected readonly cdr = inject(ChangeDetectorRef);

  public onChange = (_: T | null) => {};
  public onTouched = () => {};

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public updateValue(value: T | null): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
    this.cdr.markForCheck();
  }

  public writeValue(value: T): void {
    this.value = value;
    this.cdr.markForCheck();
  }
}
